import React, { useEffect, useState, useContext } from "react";

import Contexto from '../comun/Contexto';
import SelectReactHookForm from "../comun/SelectReactHookForm";
import { buscarCPConMismoNombre, Departamentos, traerCPs, traerMunicipios } from "../comun/Departamentos";
import { esMayorOIgualACero } from "../comun/Pagina";
import MensajeValidacion from "./MensajeValidacion";

const SelectorCP =({
    idCP, setIdCP, 
    nombreMunRef, nombreCPRef,
    register, handleSubmit, watch, errors})=> 
{
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    /** Estado */
    const [departamentos, setDepartamentos] = useState([]);
    const [municipios, setMunicipios] = useState([]);    
    const [centrosPoblados, setCentrosPoblados] = useState([]);
 
    const [idDepto, setIdDepto] = useState(-1);
    const [idMun, setIdMun] = useState(-1);    
     
    /* Efectos */
    useEffect( ()=>{ setMunicipios(traerMunicipios(urlBaseRest, idDepto, setMunicipios)) }, [idDepto] );
    useEffect( ()=>{ traerCPs(urlBaseRest, idMun, setCentrosPoblados) }, [idMun] );    
    useEffect( ()=> {         
        setIdCP(-1);
    }, [municipios])

    useEffect( ()=>{ 
        let cp = buscarCPConMismoNombre( nombreMunRef.current, centrosPoblados);
        if (cp != null) {
            setIdCP(cp.codigo);
            nombreCPRef.current=cp.nombre;
        }
    }, [centrosPoblados]);
  
    //useEffect( ()=>{ alert("idCP ha cambiado") }, [idCP] );    
 
    /** validaciones */
    const validarCentroPoblado = (valor) => {
        let val = (typeof valor !== 'undefined')  && idCP >0;       
        return val;
    };
     
    /* configuracion de react-hook-form */    
    const regSelDepto = register("selDepto", { required: true, validate: esMayorOIgualACero });
    const regSelMun = register("selMun", { required: true, validate: esMayorOIgualACero });
    const regSelCentroPob = register("selCentroPob", { validate: validarCentroPoblado });
    
    /* Manejo de cambio de htmlelements */
    const handleChangeSelDepto = (e) => {          
        setIdDepto(e.target.value);
    };
 
    const handleChangeSelMun = (e) => {    
        setIdMun(e.target.value);
        nombreMunRef.current = e.target[e.target.selectedIndex].text;        
    };
 
    const handleChangeSelCentroPob = (e) => {   
        setIdCP(e.target.value);
        nombreCPRef.current = e.target[e.target.selectedIndex].text;   
    };

    console.log("errors")
    console.log(errors)
    console.log("regSelDepto")
    console.log(regSelDepto)
 
    return (
        <React.Fragment>      
        <div>
            <div className="TextoMedianoVerde">Departamento</div>
               
            <SelectReactHookForm
            id="selDepto"
            regSel ={regSelDepto}
            handleChange={handleChangeSelDepto}
            opciones={Departamentos}
            errors={errors} 
            setMunicipios={setMunicipios}/>
        </div>

        <div>
            <div className="TextoMedianoVerde">Municipio</div>
            
            <SelectReactHookForm
            id="selMun"
            regSel ={regSelMun}
            handleChange={handleChangeSelMun}
            opciones={municipios}
            errors={errors} />    
        </div>

        <div>
            <div className="TextoMedianoVerde">Centro poblado</div>
        
            <SelectReactHookForm
            id="selCentroPob"
            regSel ={regSelCentroPob}
            handleChange={handleChangeSelCentroPob}
            opciones={centrosPoblados}
            errors={errors}
            valorDefault={idCP} />
        </div>
        </React.Fragment>
    )    
}

export default SelectorCP;